/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_OverlineInputs */

const en_mk_team_overline = /** @type {(inputs: Mk_Team_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGENT TEAMS · CLOUD & YOUR COMPUTER`)
};

const id_mk_team_overline = /** @type {(inputs: Mk_Team_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIM AGENT · CLOUD & KOMPUTER SENDIRI`)
};

/**
* | output |
* | --- |
* | "AGENT TEAMS · CLOUD & YOUR COMPUTER" |
*
* @param {Mk_Team_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_overline = /** @type {((inputs?: Mk_Team_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_overline(inputs)
	return en_mk_team_overline(inputs)
});